export class TeamClubSelection implements TeamClubSelection {
  clubIds: number[] = [];
  teamIds: number[] = [];
  subjectClassIds: number[] = [];
  excludedTeamIds: number[] = [];
  excludedClubIds: number[] = [];
  excludedSubjectClassIds: number[] = [];
}
